import { getApi } from "../base.api.js";

// Get all files
export const getAllFiles = async () => {
    const response = await getApi('files');
    console.log('Files response:', response);
    return response;
}

// Get files by MDS number
export const getFilesByMds = async (mdsNumber) => {
    const response = await getApi(`files/mds/${mdsNumber}`);
    console.log('Files by MDS response:', response);
    return response;
} 